'use strict';

class SpecificationsController {
    /*@ngInject*/
    constructor($scope, $stateParams, $state, $element, $mdDialog, orderStore, inventory, iconCache, utils, $q, auth, $mdMedia, $timeout) {
        "ngInject";
        _.extend(this, {
            name: 'specifications',
            $stateParams: $stateParams,
            $mdDialog: $mdDialog,
            $element: $element,
            $state: $state,
            orderStore: orderStore,
            inventory: inventory,
            getIconFor: iconCache,
            utils: utils,
            $q: $q,
            auth: auth,
            $scope: $scope,
            $mdMedia: $mdMedia,
            $timeout: $timeout
        });

        this.showTabHelpText = true;
        this.showCardHelpText = true;
        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId)
            .then(
                (order) => this.initialize(order),
                (error) => this.$q.reject(error)
            );

        $scope.$watch(
            () => this.addItemToCategory,
            (isClicked, prev) => {
                // Fab dial is not meant to be used in this manner
                // This is a hack to watch for click events on the root fab dial
                if (isClicked && !_.isUndefined(prev)) {
                    let selectedMajorCategoryIndex = this.selectedTabIndex,
                        selectedMajorCategory = this.itemTabs[selectedMajorCategoryIndex].qualifiedName;

                    if (selectedMajorCategory) {
                        this.addItemToColumnWith(selectedMajorCategory, this.itemTabs[selectedMajorCategoryIndex].itemColumns[0], this.itemTabs[selectedMajorCategoryIndex]);
                    }

                    // Make sure to forcibly close the empty speed dial
                    this.addItemToCategory = false;
                }
            }
        )
    }

    initialize(order) {
        this.order = order;
        this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
        this.itemTabs = this.getItemTabsFromInventory(this.flatOrderItems);
        this.setItemsVolume();
        this.selectedTabIndex = -1;
    }

    getItemTabsFromInventory(inventory) {
        let primaryItemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .map(item => {  item._complete = _.isNumber(item.identifier) && _.isUndefined(item._destroy) ? true : false; return item;})
            .filter(item => this.utils.isInPrimaryCategory(item))
            .value();

        return _(primaryItemsInInventory)
            .groupBy(item => this.utils.getRootNameOf(item, 2))
            .map((children, rootCategoryName) => this.getItemTab(rootCategoryName, children))
            .map(itemTab => _.extend(itemTab, {progress: this.getTabProgressFor(itemTab)}))
            .sort((itemA, itemB )=> {
                const itemCategoryPriorityA = this.utils.sortMajorCategories(this.utils.getRootNameOf(itemA, 1)),
                    itemCategoryPriorityB = this.utils.sortMajorCategories(this.utils.getRootNameOf(itemB, 1));

                if (itemCategoryPriorityA === itemCategoryPriorityB) {
                    return itemB.score < itemA.score;
                }

                return itemCategoryPriorityA - itemCategoryPriorityB;
            })
            .value();
    }

    getItemTab(withRootCategoryName, children) {
        return _.extend(
            this.utils.withDescriptionOf({qualifiedName: withRootCategoryName}, 2),
            {itemColumns: [children]}
        );
    }
    addItemsfab(){
        let selectedMajorCategoryIndex = this.selectedTabIndex,
            selectedMajorCategory = this.itemTabs[selectedMajorCategoryIndex].qualifiedName;

        if (selectedMajorCategory) {
            this.addItemToColumnWith(selectedMajorCategory, this.itemTabs[selectedMajorCategoryIndex].itemColumns[0], this.itemTabs[selectedMajorCategoryIndex]);
        }


        // Make sure to forcibly close the empty speed dial
    }

    getTabProgressFor(itemTab) {
        let itemsInTab = itemTab.itemColumns[0];
        const allEditableItems = _.filter(itemsInTab, (item) => _.isUndefined(item._destroy)),
            completed = _.sum(allEditableItems, (item) => item.identifier ? 1 : 0);
        return {
            total: allEditableItems.length,
            completed: completed
        };
    }

    getTabClonableItemCounts(itemTab) {
        const tabProgress = this.getTabProgressFor(itemTab),
            incomplete = tabProgress.total - tabProgress.completed;

        /**
         * incomplete === 0
         *  return []
         * incomplete === 1
         *  return [1, 2]
         * incomplete > 1
         *  return [1 .. incomplete + 1]
         *
         *  +1 is to ensure we include the current item
         */
        let adjustedCount = incomplete >= 1 ? incomplete + 1 : 0;
        return _.map(_.times(adjustedCount), (index) => index + 1);
    }

    addItemToColumnWith(qualifiedName, column, tab) {
        let item = this.inventory.getItemWithQualifiedName(qualifiedName);
        this.flatOrderItems.push(item);
        column.push(item);
        tab.progress = this.getTabProgressFor(tab);
    }

    setItemsVolume() {
        this.itemsVolume = _(this.flatOrderItems)
            .filter((item) => _.isUndefined(item._destroy))
            .map(item => {
                const itemCFT = item.cubic_feet;
                if (!_.isNumber(itemCFT)) {
                    if (_.contains(item.name, 'vehicle')) {
                        return item;
                    }
                }
                return item;
            })
            .sum('cubic_feet');
    }

    getIconForItem(item) {
        const itemIsComplete = item._complete === true,
            itemNameForIcon = itemIsComplete ? this.utils.getRootNameOf(item, 2).split('.')[1] : item.name,
            cssIconClass = ['piko-icon-', itemNameForIcon.toLowerCase()].join('');

        let cssClasses = {};
        cssClasses[cssIconClass] = true;

        return cssClasses;
    }

    getRootDescriptionForItem(item) {
        const rootItem = this.utils.withDescriptionOf({qualifiedName: this.utils.getRootNameOf(item, 2)});
        return rootItem.displayName.toLowerCase();
    }

    onItemClick(evt) {
        let action = evt.action,
            selectedItem = evt.item,
            selectedItemIndex = evt.itemIndex,
            selectedItemColumn = evt.column,
            selectedItemColumnIndex = evt.columnIndex,
            selectedItemTab = evt.tab,
            selectedItemTabIndex = evt.tabIndex;

        // For the purposes of marking as selected
        selectedItemColumn.selectedItemIndex = selectedItemIndex;

        /**
         * TODO - I'm lazy right now and this section looks like shit.
         * FIXIT
         */
        switch (action) {
            case 'add':
                /**
                 * If an item has been completely specified,
                 *  prevent any further editing unless an edit action
                 *  has been specifically called - taken care of by a different case
                 */
                if (selectedItem._complete) {
                    return false;
                }

                /**
                 * The 'clone to other incomplete items' option should
                 *  only be shown immediately after an item has been
                 *  completely described.
                 *  On any further interaction, this should be emptied
                 */
                selectedItemTab.clones = [];

                /**
                 * If an add event occurs on the first column in a tab,
                 *  1. Reset column selected indices on any other column which may be present.
                 *     This required as item columns are populated by objects that are passed by reference.
                 *  2. Remove all columns from tab except for the first
                 *  3. Calculate the actual index of selected item in the first itemColumn.
                 *     This is required as we filter out all destroyed elements before displaying them to the user.
                 *     Destroyed elements have to still be maintained to be passed along to the server to be deleted.
                 *     ng-repeat $index now returns only the index which is visible to it.
                 *  4. Set the activeCardIndex of the itemTab as the actualSelectedItemIndex.
                 *     This is a reference for later processes which may need to know
                 *     which card is currently being detailed, deleted, etc
                 *  5. Recalculate the progress of this itemTab.
                 */
                if (selectedItemColumnIndex === 0) {
                    this.resetColumnsInTab(selectedItemTab);
                    selectedItemTab.activeCardIndex = this.actualSelectedItemIndex(selectedItemTab.itemColumns[0], selectedItem);
                    selectedItemTab.progress = this.getTabProgressFor(selectedItemTab);
                }

                /**
                 * If the user selects an from a previous column,
                 *  delete all columns after the selected column
                 * The minus 1 is because we're comparing using zero based array indices
                 * The plus 1 is because _.take expects a length and not an array index
                 */
                else if (selectedItemColumnIndex < selectedItemTab.itemColumns.length - 1) {
                    this.resetColumnsSelectedIndex(selectedItemTab.itemColumns, selectedItemColumnIndex);
                    selectedItemTab.itemColumns = _.take(selectedItemTab.itemColumns, selectedItemColumnIndex + 1);
                }


                // Check if the item has any more qualifiers after it's current state
                let selectedItemQualifiedName = this.contextAwareQualifiedName(selectedItem, selectedItemColumnIndex),
                    additionalQualifiersForSelectedItem = this.inventory.getChildrenFor(selectedItemQualifiedName);

                if (additionalQualifiersForSelectedItem.length) {
                    // Extend item with custom icons if required
                    additionalQualifiersForSelectedItem = additionalQualifiersForSelectedItem.map((item) => {
                        let iconForItem = this.utils.getIconFor(item.qualifiedName);
                        return _.extend(item, {
                            hasCustomIcon: !_.isUndefined(iconForItem.hasCustomIcon),
                            hasDuplicatedIcon: !_.isUndefined(iconForItem.hasDuplicatedIcon),
                            icon: iconForItem.icon
                        });
                    });
                    selectedItemTab.itemColumns.push(additionalQualifiersForSelectedItem);
                    this.onSwipe('right', selectedItemTab, selectedItemColumnIndex);
                } else {
                    this.resetColumnsInTab(selectedItemTab);
                }

                /**
                 * The item has been completely detailed.
                 * 1. Extend the item with the leaf node properties
                 *    obtained from the inventory.
                 * 2. Recalculate tab progress
                 * 3. Check if the clone option is applicable
                 */
                if (additionalQualifiersForSelectedItem.length === 0 && _.isNumber(selectedItem.identifier) && _.isUndefined(selectedItem._destroy)) {
                    this.completeRootItemOf(selectedItem, selectedItemTab);
                    selectedItemTab.progress = this.getTabProgressFor(selectedItemTab);
                    selectedItemTab.clones = this.getTabClonableItemCounts(selectedItemTab);
                    this.onSwipe('right', selectedItemTab, 0);
                }

                break;
            case 'clone':
                const numberOfClones = evt.clone;

                if (numberOfClones > 0) {
                    /**
                     * 1. Get an item from inventory which matches properties of the selected item.
                     * 2. Find the number of incomplete items in tab taking into account
                     *      both genuinely incomplete items and destroyed items.
                     * 3. Take @numberOfClones from (2) and extend with (1)
                     *
                     * We don't extend clones with the selected item to preserve any existing
                     *  database related ids that may be present.
                     */
                    const itemClone = this.inventory.getItemWithQualifiedName(selectedItem.qualifiedName);

                    let incompleteItemsInColumn = this.incompleteItems(selectedItemTab.itemColumns[0]),
                        cloneableItems = _.take(incompleteItemsInColumn, numberOfClones);
                    _.forEach(cloneableItems, (item) => _.extend(item, itemClone, {_complete: true}));
                }

                // Recalculate the tab progress in the event items were cloned
                selectedItemTab.progress = this.getTabProgressFor(selectedItemTab);

                // Hide the clone menu
                selectedItemTab.clones = [];
                break;
            case 'edit':
                this.resetColumnsInTab(selectedItemTab);
                this.resetRootItemOf(selectedItem, selectedItemTab);

                // Recalculate the progress for tab, an item has been removed
                selectedItemTab.progress = this.getTabProgressFor(selectedItemTab);
                // Hide the clone menu
                selectedItemTab.clones = [];

                this.$timeout(() => this.resetTabScroll(selectedItemTab));

                break;
            case 'remove':
                this.deleteRootItemOf(selectedItem, selectedItemTab);

                this.resetColumnsInTab(selectedItemTab);
                selectedItemTab.progress = this.getTabProgressFor(selectedItemTab);
                selectedItemTab.clones = [];

                this.$timeout(() => this.resetTabScroll(selectedItemTab));
                break;
        }

        this.setItemsVolume();
    }

    /**
     * selectedItemIndex is a flag used to
     *  keep track of which item was last clicked in a column.
     * This is then shown to user as an underlined card.
     * This function resets this flag to undefined
     *  for all columns in a tab except the first one
     * @param columns
     */
    resetColumnsSelectedIndex(columns, selectedItemColumnIndex) {
        selectedItemColumnIndex = selectedItemColumnIndex || 0;
        _.forEach(columns, (column, index) => {
            if (index > selectedItemColumnIndex) {
                delete column.selectedItemIndex;
            }
        });
    }

    /**
     *
     * @param columns All the items in the first column of active tab
     * @param selectedItem The actual item that was selected
     */
    actualSelectedItemIndex(items, selectedItem) {
        return _.findIndex(items, (item) => item === selectedItem);
    }

    /**
     * If a user clicks on the first column of a tab,
     *  regardless of the level to which the item has been specified,
     *  we need to take only root name upto a hierarchy of 2
     * @param selectedItem
     * @param selectedItemColumnIndex
     */
    contextAwareQualifiedName(selectedItem, selectedItemColumnIndex) {
        return selectedItemColumnIndex === 0 ?
            this.utils.getRootNameOf(selectedItem, 2) :
            selectedItem.qualifiedName;
    }

    resetColumnsInTab(tab) {
        this.resetColumnsSelectedIndex(tab.itemColumns);
        tab.itemColumns = [tab.itemColumns.shift()];
    }

    /**
     * Incomplete items do not have an identifier and are not destroyed
     * @param items
     * @returns {Array}
     */
    incompleteItems(items) {
        return _.filter(items, (item) =>
            _.isUndefined(item.identifier) && _.isUndefined(item._destroy)
        );
    }

    activeRootItemInTab(tab) {
        return tab.itemColumns[0][tab.activeCardIndex];
    }

    resetRootItemOf(selectedItem, inSelectedItemTab) {
        let unspecifiedItem = this.inventory.getItemWithQualifiedName(this.utils.getRootNameOf(selectedItem, 2));
        _.extend(
            selectedItem,
            unspecifiedItem,
            {description: undefined}
        );
        delete selectedItem.hasCustomIcon;
        delete selectedItem.hasDuplicatedIcon;
        delete selectedItem.icon;
        delete selectedItem._complete;
        //delete selectedItem.identifier;
        /**
         * The only thing persisted in the DB for saved
         * order item details is 'item_statistic_id'.
         * Since we do not have access to all these ids on the client side,
         *  we perform this ugly and potentially nuke worthy hack here
         *  to force the back end to update the item using the client provided identifier and version
         */
        selectedItem.item_statistic_id = -1;
    }

    completeRootItemOf(selectedItem, inSelectedItemTab) {
        let fullySpecifiedItem = this.inventory.getItemWithQualifiedName(this.utils.getRootNameOf(selectedItem, 6));
        _.extend(
            this.activeRootItemInTab(inSelectedItemTab),
            fullySpecifiedItem,
            {_complete: true}
        );
    }

    deleteRootItemOf(selectedItem, inSelectedItemTab) {
        selectedItem._destroy = true;
        delete selectedItem._complete;
        //delete selectedItem.identifier;
    }

    resetTabScroll(itemTab) {
        const toViewElementId = "itemTab__column--" + itemTab.qualifiedName + "-0";
        const toViewElement = document.querySelector("[pk-component-id='"+  toViewElementId + "']");

        const scrollParentId = "itemTab__container--" + itemTab.qualifiedName;
        const scrollParent = document.querySelector("[pk-component-id='" + scrollParentId + "']");

        const scrollableElement = scrollParent.parentElement;
        this.centerColumnHorizontally(toViewElement, 0, itemTab.itemColumns.length, scrollParent, scrollableElement);
    }

    onSwipe(direction, itemTab, swipedColumnIndex) {
        /**
         * Respond only on mobile screens
         */
        const isMobileView = this.$mdMedia('max-width: 1024px');
        if (!isMobileView) {
            return false;
        }

        const scrollParentId = "itemTab__container--" + itemTab.qualifiedName;
        const scrollParent = document.querySelector("[pk-component-id='" + scrollParentId + "']");

        if (!scrollParent) {
            return false;
        }

        const scrollableElement = scrollParent.parentElement;
        this.centerColumnHorizontally(itemTab.itemColumns.length, scrollParent, scrollableElement);
    }

    updateScrollWidth(columns, scrollParent) {
        if (columns === 1) {
            angular.element(scrollParent).css('width', "auto");
        } else {
            angular.element(scrollParent).css('width', (columns * 300) + "px");
        }
    }

    centerColumnHorizontally(totalColumns, scrollParent, scrollElement) {
        /**
         * Respond only on mobile screens
         */
        const isMobileView = this.$mdMedia('max-width: 1024px');
        if (!isMobileView) {
            return false;
        }

        this.updateScrollWidth(totalColumns, scrollParent);
        scrollElement.scrollLeft = scrollElement.scrollWidth;
    }

    continueWithIncompleteDetails(evt) {
        this.$mdDialog.show({
            controller($scope, $mdDialog) {
                "ngInject";
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
                $scope.proceed = function(continueWithIncompleteDetails) {
                    $mdDialog.hide(continueWithIncompleteDetails);
                };
            },
            template: require('common/popup.component/Nextpopup.html'),
            parent: angular.element(document.body),
            targetEvent: evt,
            clickOutsideToClose: true
        })
        .then((continueWithIncompleteDetails) => {
            const allItemsAreDetailed = _.every(this.flatOrderItems, (item) => !_.isUndefined(item.identifier) || item._destroy);
            let updatedOrder = this.getUpdatedOrder(this.orderStore.status.DRAFTED);
            updatedOrder.is_skipped = !allItemsAreDetailed;

            /**
             * If we have the user's contact details,
             *  save order and continue to acknowledgement page.
             *
             * Else, take the user to the contact details page.
             * Once the details have been confirmed,
             *  go to acknowledgement page.
             */

            this.orderLoader = this.orderStore.saveOrder(updatedOrder)
                .then(
                    (order) => {
                        let nextState, redirectState;
                        if (this.auth.isAuthenticated()) {
                            this.$state.go('base.acknowledge', {orderId: order.id});
                        } else if (this.auth.isAdminUser() && !order.user_id) {
                            nextState = this.utils.getAdminStateIfApplicable('base.login');
                            this.$state.go(nextState, {orderId: order.id});
                        } else {
                            redirectState = this.utils.getAdminStateIfApplicable('base.acknowledge');
                            nextState = this.utils.getAdminStateIfApplicable('base.login');
                            this.$state.go(nextState, {orderId: order.id}, redirectState);
                        }
                    },
                    (error) => console.log(error)
                );
        });

    }

    getUpdatedOrder(status) {
        let secondaryItemsInInventory = _(this.flatOrderItems)
            .filter(item => !this.utils.isInPrimaryCategory(item))
            .value();
        let updatedInventoryItems = _(this.flatOrderItems)
            .filter(item => this.utils.isInPrimaryCategory(item))
            .value()
            .concat(secondaryItemsInInventory);
        let mergedInventoryItems = this.utils.mergeOrderItems(updatedInventoryItems);

        let order = _.cloneDeep(this.order);
        order.order_items = mergedInventoryItems;
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);
        order.status = status;

        return order;
    }



    skipSpecifications(evt) {

        this.$mdDialog.show({
                controller($scope, $mdDialog) {
                    "ngInject";
                    $scope.cancel = function() {
                        $mdDialog.cancel();
                    };
                    $scope.proceed = function(continueWithIncompleteDetails) {
                        $mdDialog.hide(continueWithIncompleteDetails);
                    };
                },
                template: require('common/popup.component/skip.popup.html'),
                parent: angular.element(document.body),
                targetEvent: evt,
                clickOutsideToClose: true
            })
            .then((continueWithIncompleteDetails) => {
                const allItemsAreDetailed = _.every(this.flatOrderItems, (item) => !_.isUndefined(item.identifier) || item._destroy);
                let updatedOrder = this.getUpdatedOrder(this.orderStore.status.DRAFTED);
                updatedOrder.is_skipped = true;
                woopra.track("skip-option-availed", {
                    order_id : this.order.id
                });

                /**
                 * If we have the user's contact details,
                 *  save order and continue to acknowledgement page.
                 *
                 * Else, take the user to the contact details page.
                 * Once the details have been confirmed,
                 *  go to acknowledgement page.
                 */

                this.orderLoader = this.orderStore.saveOrder(updatedOrder)
                    .then(
                        (order) => {
                            let nextState, redirectState;
                            if (this.auth.isAuthenticated()) {
                                this.$state.go('base.acknowledge', {orderId: order.id});
                            } else if (this.auth.isAdminUser() && !order.user_id) {
                                nextState = this.utils.getAdminStateIfApplicable('base.login');
                                this.$state.go(nextState, {orderId: order.id});
                            } else {
                                redirectState = this.utils.getAdminStateIfApplicable('base.acknowledge');
                                nextState = this.utils.getAdminStateIfApplicable('base.login');
                                this.$state.go(nextState, {orderId: order.id}, redirectState);
                            }
                        },
                        (error) => console.log(error)
                    );
            });
    }

    saveAsDraft() {
        let updatedOrder = this.getUpdatedOrder(this.orderStore.status.DRAFTED);

        /**
         * If we have the user's contact details,
         * save order and stay on page.
         *
         * Else, take the user to the contact details page.
         * Once the details have been confirmed,
         *  redirect the user to this page.
         */

        this.orderLoader = this.orderStore.saveOrder(updatedOrder)
            .then(
                (order) => {
                    if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && updatedOrder.user_id)) {
                        this.utils.showAlertPopup('Order Saved!', 'Order Saved', 'Your order has been saved')
                            .then(() => {
                                this.initialize(order);
                                let nextState = this.utils.getAdminStateIfApplicable('base.specifications');
                                this.$state.go(nextState, {orderId: order.id});
                            });
                    } else {
                        let nextState = this.utils.getAdminStateIfApplicable('base.login'),
                            redirectState = this.utils.getAdminStateIfApplicable('base.specifications');
                        this.$state.go(nextState, {orderId: this.order.id, redirect: redirectState, showSavePopup: true});
                    }
                },
                (error) => {
                    console.log(error);
                    return error;
                }
            );

    }

    goToOthersIfDone(evt) {
        const allMajorItems = _.filter(this.flatOrderItems, item => this.utils.isInPrimaryCategory(item));
        const allItemsAreDetailed = _.every(allMajorItems, (item) => !_.isUndefined(item.identifier) || item._destroy);

        if (!allItemsAreDetailed) {
            this.$scope.showValidation = true;
            return this.continueWithIncompleteDetails(evt);
        }

        return this.next();
    }

    next() {

        let status = this.orderStore.status.DRAFTED;
        if (this.order.property_type.toLowerCase() === 'vehicle') {
            status = this.orderStore.status.CREATED;
        }

        this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(status))
            .then(
                (order) => {
                    let nextState;
                    /**
                     * If the property type is vehicle,
                     *  move directly to quotes.
                     * Else, show the others page
                     */
                    if (order.property_type.toLowerCase() === 'vehicle') {
                        /**
                         * If we have the user's contact details,
                         *  go to acknowledgement page,
                         * Else, collect the contact details and then proceed
                         */
                        if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && order.user_id)) {
                            nextState = this.utils.getAdminStateIfApplicable('base.acknowledge');
                            return this.$state.go(nextState, {orderId: order.id});
                        }

                        nextState = this.utils.getAdminStateIfApplicable('base.login');
                        return this.$state.go(nextState, {orderId: order.id});
                    }

                    nextState = this.utils.getAdminStateIfApplicable('base.others');
                    this.$state.go(nextState, {orderId: order.id});
                },
                (error) => console.log(error)
            );
    }
}

export default SpecificationsController;


// WEBPACK FOOTER //
// ./client/app/components/specifications/specifications.controller.js